import axios from 'axios'
import create from 'zustand'
import { persist } from 'zustand/middleware'
import Cookies from 'js-cookie'


//#region courseset store
let store = (set) => ({
  // store coursesets
  coursesets: {},
  // get All coursesets
  coursesetBaseOnMajor: {},
  categoryCourses: {},
  coursesetCount: 0,
  // get All coursesets
  getcoursesets: async () => {
    // setting token
    let token = Cookies.get('token')

    // attach token to header
    // sort and order data by which column and how
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
      params: {
        sortBy: 'courseset.id',
        orderBy: 'desc',
      },
    }
    // setting url
    // main url comes from .env file
    const apiResponse = await axios.get(
      `${process.env.REACT_APP_API}/courseset`,
      config
    )
    set(async (state) => {
      // initilize coursesets state variable to the responsed coursesets if request succeed
      if (apiResponse?.status == 200 || apiResponse?.status == 201)
        state.coursesets = apiResponse.data
    })
  },
  getCategoryCourses: async () => {
    // setting token
    let token = Cookies.get('token')

    // attach token to header
    // sort and order data by which column and how
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
      params: {
        sortBy: 'courseset.id',
        orderBy: 'desc',
        search: '...'
      },
    }
    // setting url
    // main url comes from .env file
    const apiResponse = await axios.get(
      `${process.env.REACT_APP_API}/courseset/`,
      config
    )
    set(async (state) => {
      // initilize coursesets state variable to the responsed coursesets if request succeed
      if (apiResponse?.status == 200 || apiResponse?.status == 201)
        state.categoryCourses = apiResponse.data
    })
  },
  getcoursesetCount: async () => {
    // setting token
    let token = Cookies.get('token')

    // attach token to header
    // sort and order data by which column and how
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      }
    }
    // setting url 
    // main url comes from .env file
    const apiResponse = await axios.get(`${process.env.REACT_APP_API}/courseset/getcount`, config)
    set(async (state) => {
      // initilize coursesets state variable to the responsed coursesets if request succeed
      if (apiResponse?.status == 200 || apiResponse?.status == 201)
        state.coursesetCount = apiResponse?.data?.courseset ?? ''
    })
  },
  getcoursesetBaseOnMajor: async () => {
    // setting token
    let token = Cookies.get('token')

    // attach token to header
    // sort and order data by which column and how
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
      params: {
        search: '...'
      },
      // params: {
      //   sortBy: 'courseset.id',
      //   orderBy: 'desc',
      // }
    }

    let major = Cookies.get('major')
    let cohort = Cookies.get('cohort')
    major = JSON.parse(major)?.id ?? '-1'
    cohort = JSON.parse(cohort)?.id ?? '-1'

    // setting url
    // main url comes from .env file
    const apiResponse = await axios.get(
      `${process.env.REACT_APP_API}/courseset/rank/all?major=${major}&cohort=${cohort}`,
      config
    )
    set(async (state) => {
      // initilize coursesets state variable to the responsed coursesets if request succeed
      if (apiResponse?.status == 200 || apiResponse?.status == 201)
        state.coursesetBaseOnMajor = apiResponse.data
    })
  },
  addcourseset: async (payload) => {
    // setting token
    let token = Cookies.get('token')

    // attaching token to the header
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }

    // setting url
    // main url comes from .env file
    const apiResponse = await axios.post(
      `${process.env.REACT_APP_API}/courseset`,
      payload,
      config
    )
    if (apiResponse?.status === 201) {
      set(async (state) => {
        // initilizing coursesets state variable to the resoponsed data
        state.coursesets = {
          data: [apiResponse.data, ...state.coursesets.data],
          limit: state.coursesets.limit,
          page: state.coursesets.page,
          totalCount: state.coursesets.totalCount + 1,
        }
      })
    }
    return apiResponse
  },
  editcourseset: async (payload, id) => {
    // setting token
    let token = Cookies.get('token')

    // attaching token to the header
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }

    // setting url
    // main url comes from .env file
    const apiResponse = await axios.patch(
      `${process.env.REACT_APP_API}/courseset/${id}`,
      payload,
      config
    )
    // update coursesets state variable if update request was succeed
    if (apiResponse?.status === 200) {
      set(async (state) => {
        const result = state.coursesets?.data?.find((courseset, index) => {
          if (courseset.id === id) {
            state.coursesets.data[index] = apiResponse?.data
          }
        })

        state.coursesets = {
          data: [...state.coursesets.data],
          limit: state.coursesets.limit,
          page: state.coursesets.page,
          totalCount: state.coursesets.totalCount,
        }
      })
    }
    return apiResponse
  },
  deletecourseset: async (id) => {
    // setting token
    let token = Cookies.get('token')

    // attaching token to the header
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }
    // setting url
    // main url comes from .env file
    const apiResponse = await axios.delete(
      `${process.env.REACT_APP_API}/courseset/${id}`,
      config
    )
    // delete element in the coursesets.data array state if the request was succeed
    if (apiResponse?.status === 200) {
      set(async (state) => {
        const arr = state.coursesets.data.filter((item) => item.id !== id)
        state.coursesets = {
          data: arr,
          limit: state.coursesets.limit,
          page: state.coursesets.page,
          totalCount: state.coursesets.totalCount - 1,
        }
      })
    }

    return apiResponse
  },
})
//#endregion courseset store

// store the state in the browser local storage
// store = persist(store, { name: 'courseset' })

// getting store data in the browser localstorage
const courseset_Store = create(store)

export default courseset_Store
